// extracted by mini-css-extract-plugin
export default {"main":"WebcamPage_main__ZOXqz","block":"WebcamPage_block__U7BzH","intro":"WebcamPage_intro__efug9","introText":"WebcamPage_introText__EW1tb","content":"WebcamPage_content__zaHlG"};